import { HttpContextToken } from '@angular/common/http';

/** Excludes requests generated automatically (polls, startup hydration, refresh) from session activity. */
export const SKIP_SESSION_ACTIVITY = new HttpContextToken<boolean>(() => false);